var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "1000", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("business")]),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.form.id
                      ? _vm.$t("parametro.crud.editParametro")
                      : "Nuevo funcionario"
                  ) +
                  "\n      "
              ),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _vm._v("\n        Datos Básicos\n        "),
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_de_documentos,
                                  "item-text": "descripcion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  rules: _vm.$validate(["required"]),
                                  label: "Tipo de documento"
                                },
                                model: {
                                  value: _vm.persona.id_tipo_documento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.persona,
                                      "id_tipo_documento",
                                      $$v
                                    )
                                  },
                                  expression: "persona.id_tipo_documento"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Número de Documento",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "11"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.obtenerNrodoc()
                                  }
                                },
                                model: {
                                  value: _vm.persona.nro_doc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "nro_doc", $$v)
                                  },
                                  expression: "persona.nro_doc"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Complemento",
                                  required: "",
                                  maxlength: "6"
                                },
                                model: {
                                  value: _vm.persona.nro_complemento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.persona,
                                      "nro_complemento",
                                      $$v
                                    )
                                  },
                                  expression: "persona.nro_complemento"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_expedido,
                                  "item-text": "valor",
                                  "item-value": "valor",
                                  label: "Expedido en"
                                },
                                model: {
                                  value: _vm.persona.expedido,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "expedido", $$v)
                                  },
                                  expression: "persona.expedido"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Sexo",
                                  items: _vm.generos,
                                  "item-text": "nombre",
                                  "item-value": "value",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "1"
                                },
                                model: {
                                  value: _vm.persona.sexo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "sexo", $$v)
                                  },
                                  expression: "persona.sexo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Apellido Paterno",
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.ap_paterno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "ap_paterno", $$v)
                                  },
                                  expression: "persona.ap_paterno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Apellido Materno",
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.ap_materno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "ap_materno", $$v)
                                  },
                                  expression: "persona.ap_materno"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Apellido Casada",
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.ap_casada,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "ap_casada", $$v)
                                  },
                                  expression: "persona.ap_casada"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Nombres",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.nombres,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "nombres", $$v)
                                  },
                                  expression: "persona.nombres"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v("\n\n        Alta del Servidor Publico\n        "),
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha de incorporación",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.itemsDisponibles,
                                  "item-text": "nro_item",
                                  "item-value": function(val) {
                                    return val.nro_item
                                  },
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "ITEM",
                                  loading: _vm.loading
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.cargarDatos()
                                  }
                                },
                                model: {
                                  value: _vm.form.nro_item,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_item", $$v)
                                  },
                                  expression: "form.nro_item"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.unidades,
                                  label: "Unidad",
                                  "item-text": "nombre_unidad",
                                  "item-value": "id",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.movilidad.id_unidad,
                                  callback: function($$v) {
                                    _vm.$set(_vm.movilidad, "id_unidad", $$v)
                                  },
                                  expression: "movilidad.id_unidad"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_cargo,
                                  "item-text": "denominacion",
                                  "item-value": "id",
                                  rules: _vm.$validate(["required"]),
                                  label: "Seleccione Cargo"
                                },
                                model: {
                                  value: _vm.movilidad.id_cargo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.movilidad, "id_cargo", $$v)
                                  },
                                  expression: "movilidad.id_cargo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_puesto,
                                  "item-text": "nombre_puesto",
                                  "item-value": "id",
                                  rules: _vm.$validate(["required"]),
                                  label: "Seleccione Puesto"
                                },
                                model: {
                                  value: _vm.movilidad.id_puesto,
                                  callback: function($$v) {
                                    _vm.$set(_vm.movilidad, "id_puesto", $$v)
                                  },
                                  expression: "movilidad.id_puesto"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nro de Memorándum",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.movilidad.nro_memorandum,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.movilidad,
                                      "nro_memorandum",
                                      $$v
                                    )
                                  },
                                  expression: "movilidad.nro_memorandum"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.repetido
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            type: "submit",
                            disabled: !_vm.valid,
                            loading: _vm.loading
                          }
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("check")
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.save")) + "\n        "
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d539408", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d539408","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/persona/dialogs/CrearPersona.vue
// module id = null
// module chunks = 